/**
 * Site Header — mobile navigation toggle.
 *
 * Handles open/close of the collapsible nav (#site-header-nav) and
 * the hamburger animation on .js-toggle-menu.
 */
export class HeaderMenu {
	constructor() {
		this.$toggle = jQuery( '.js-toggle-menu' );
		this.$nav    = jQuery( '#site-header-nav' );

		if ( ! this.$toggle.length || ! this.$nav.length ) return;

		this.init();
	}

	init() {
		// Toggle on hamburger click
		this.$toggle.on( 'click', () => {
			const isOpen = this.$toggle.attr( 'aria-expanded' ) === 'true';
			isOpen ? this.closeNav() : this.openNav();
		} );

		// Close when any nav link is clicked (navigation happened)
		this.$nav.find( 'a' ).on( 'click', () => {
			this.closeNav();
		} );

		// Close if viewport widens past the mobile breakpoint
		jQuery( window ).on( 'resize.headerMenu', () => {
			if ( window.innerWidth >= 992 ) {
				this.closeNav();
			}
		} );
	}

	openNav() {
		this.$toggle
			.attr( 'aria-expanded', 'true' )
			.addClass( 'is-active' );
		this.$nav
			.addClass( 'is-open' )
			.attr( 'aria-hidden', 'false' );
	}

	closeNav() {
		this.$toggle
			.attr( 'aria-expanded', 'false' )
			.removeClass( 'is-active' );
		this.$nav
			.removeClass( 'is-open' )
			.attr( 'aria-hidden', 'true' );
	}
}
